type Props = {
  heading: string;
  caption: string;
  showError?: boolean;
  errorMessage?: string;
};

export const SectionHeader = ({ heading, caption, showError, errorMessage }: Props) => (
  <div className='section-header'>
    <h1>{heading}</h1>
    <p>{caption}</p>
    {showError && <p className='error-message'>{errorMessage}</p>}
  </div>
);
